export default __webpack_public_path__ + "static/media/mobility.517541d1.png";